import { Job } from '../../domain/models/job';
import { Schedule } from '../../domain/models/schedule';
import { JobStatus } from '../../domain/enums/jobStatus';
import { Project } from '../../domain/models/project';
import * as _ from 'lodash';

export class ProjectOverviewViewModel {
    public id: string;
    public userId: string;
    public companyId: string;
    public sharingKey: string;

    public name: string;
    public description: string;
    public creationDate: Date;
    public archived: boolean;
    public jobs: Array<ProjectJobOverviewViewModel>;

    public usedQuota: number;
    public maxInvalidRoutesExceeded: boolean;
    public invalidCsvFormatLines: number[];
    public failedCsvLines: number[];

    constructor(project: Project) {
        this.id = project.id;
        this.userId = project.userId;
        this.sharingKey = project.sharingKey;
        this.companyId = project.companyId;
        this.name = project.name;
        this.description = project.description;
        this.archived = project.archived;
        this.creationDate = project.creationDate;
        this.jobs = project.jobs.map((job: Job) => new ProjectJobOverviewViewModel(job));
        this.usedQuota = 0;
        this.maxInvalidRoutesExceeded = false;
        this.invalidCsvFormatLines = [];
        this.failedCsvLines = [];
    }
}

export class ProjectJobOverviewViewModel {
    public id: string;
    public name: string;
    public userId: string;
    public daysCalculated: number;
    public totalDays: number;
    public fromDate: Date;
    public toDate: Date;
    public active: boolean;
    public archived: boolean;
    public createdDate: Date;
    public currentDelay: number;
    public startTime: string;
    public endTime: string;
    public status: JobStatus;
    public finishedAt: Date;
    public needsCorrection: boolean;
    public fromCsv: boolean;
    public cost: number;

    constructor();
    constructor(json: any)
    constructor(idOrJson: any, name: string, daysCalculated: number, totalDays: number, fromDate: Date,
        toDate: Date, active: boolean, archived: boolean, createdDate: Date, currentDelay: number, fromCsv: boolean, needsCorrection: boolean);
    constructor(idOrJson?: any, name?: string, daysCalculated?: number, totalDays?: number, fromDate?: Date,
        toDate?: Date, active?: boolean, archived?: boolean, createdDate?: Date, currentDelay?: number) {
        if (idOrJson) {
            if (name) {
                this.id = idOrJson;
                this.name = name;
                this.daysCalculated = daysCalculated;
                this.totalDays = totalDays;
                this.fromDate = fromDate;
                this.toDate = toDate;
                this.active = active;
                this.archived = archived;
                this.createdDate = createdDate;
                this.currentDelay = currentDelay;
            } else {
                this.id = idOrJson.id;
                this.name = idOrJson.name;
                this.fromDate = idOrJson.start;
                this.toDate = idOrJson.end;
                this.active = this.toDate !== null && this.toDate !== undefined && new Date().getTime() < this.toDate.getTime();
                this.startTime = idOrJson.schedule.startTime;
                this.endTime = idOrJson.schedule.endTime;
                this.totalDays = 0;
                this.daysCalculated = 0;
                this.archived = idOrJson.archived;
                this.createdDate = idOrJson.createdAt;
                this.status = idOrJson.status;
                this.userId = idOrJson.userId;
                this.finishedAt = idOrJson.finishedAt;
                this.fromCsv = idOrJson.fromCsv;
                this.needsCorrection = idOrJson.needsCorrection;
                this.cost = idOrJson.cost;

                this.calulateTotalDays(idOrJson.schedule, idOrJson.start, idOrJson.end, this.finishedAt);
            }
        }
    }

    private calulateTotalDays(schedule: Schedule, startDate: Date, endDate: Date, finishedAt: Date): void {
        let stop = new Date(endDate);
        stop.setHours(0, 0, 0, 0);
        let today = new Date();
        if (finishedAt) {
            today = new Date(finishedAt);
            today.setDate(today.getDate() + 1);
        }
        today.setHours(0, 0, 0, 0);

        let start = new Date(startDate);
        start.setHours(0, 0, 0, 0);

        for (let i = new Date(start); i <= stop; i.setDate(i.getDate() + 1)) {
            if (_.includes(schedule.days, i.getDay())) {
                this.totalDays++;
                if (i < today) {
                    this.daysCalculated++;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/project-overview/viewModels/project-overview.viewModel.ts